import { useState } from 'react';

const Pricing = () => {
  const [billingCycle, setBillingCycle] = useState('mensal');

  return (
    <section id="precos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Cards de Preços */}
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-6">
            {/* Plano DP - Cálculo de Pontos */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 relative">
              {/* Header do Card */}
              <div className="mb-6">
                <div className="flex items-center mb-3">
                  <div className="w-6 h-6 bg-gray-800 rounded flex items-center justify-center mr-3">
                    <i className="ri-file-text-line text-white text-sm"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">DP - Cálculo de Pontos</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Dashboard Cálculos de Pontos + Recibos Avulsos + Caixa Postal do DP + Calculadora de INSS/IRRF + Simulador do Seguro Desemprego + Grupo de Membros no WhatsApp
                </p>
              </div>

              {/* Preço */}
              <div className="mb-6">
                <div className="flex items-baseline mb-2">
                  <span className="text-3xl font-bold text-gray-900">R$ 34,99</span>
                  <span className="text-gray-500 ml-1">/mês</span>
                </div>
              </div>

              {/* Lista de Funcionalidades */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Dashboard de Cálculo de Ponto</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm line-through text-red-500">Dashboard de Cálculo de Rescisões</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Gerador de Recibos Avulsos</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Caixa Postal do DP</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Tabela de Rubricas</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Calculadora INSS/IRRF</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Seguro Desemprego</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Grupo WhatsApp</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
              </div>

              {/* Botões de Preço */}
              <div className="space-y-3">
                <button 
                  className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-600 transition-colors whitespace-nowrap"
                  onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                >
                  Mensal - R$ 34,99
                </button>
                <div className="relative">
                  <button 
                    className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Semestral - R$ 147,00
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-30%</span>
                </div>
                <div className="relative">
                  <button 
                    className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Anual - R$ 259,99
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-38%</span>
                </div>
              </div>
            </div>

            {/* Plano Premium (Recomendado) */}
            <div className="bg-white rounded-2xl shadow-xl border-2 border-orange-400 p-6 relative scale-105 lg:scale-110">
              {/* Badge Recomendado */}
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-orange-400 text-white px-4 py-2 rounded-full text-sm font-bold">
                  Recomendado
                </span>
              </div>

              {/* Header do Card */}
              <div className="mb-6 mt-4">
                <div className="flex items-center mb-3">
                  <div className="w-6 h-6 bg-orange-400 rounded flex items-center justify-center mr-3">
                    <i className="ri-crown-line text-white text-sm"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">Plano Premium</h3>
                </div>
                <p className="text-orange-600 text-sm font-semibold mb-2">
                  Combo: DP Pontos + Rescisão
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Dashboard Cálculos de Pontos + Recibos Avulsos + Caixa Postal do DP + Calculadora de INSS/IRRF + Simulador do Seguro Desemprego + Grupo de Membros no WhatsApp
                </p>
              </div>

              {/* Preço */}
              <div className="mb-6">
                <div className="flex items-baseline mb-2">
                  <span className="text-3xl font-bold text-gray-900">R$ 39,99</span>
                  <span className="text-gray-500 ml-1">/mês</span>
                </div>
              </div>

              {/* Lista de Funcionalidades */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm font-medium">Dashboard de Cálculo de Ponto</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm font-medium">Dashboard de Cálculo de Rescisões</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Gerador de Recibos Avulsos</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Caixa Postal do DP</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Tabela de Rubricas</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Calculadora INSS/IRRF</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Seguro Desemprego</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Grupo WhatsApp</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
              </div>

              {/* Botões de Preço */}
              <div className="space-y-3">
                <button 
                  className="w-full bg-orange-400 text-white py-3 px-4 rounded-lg font-semibold hover:bg-orange-500 transition-colors whitespace-nowrap"
                  onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                >
                  Mensal - R$ 39,99
                </button>
                <div className="relative">
                  <button 
                    className="w-full bg-white border-2 border-orange-200 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Semestral - R$ 147,00
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-38%</span>
                </div>
                <div className="relative">
                  <button 
                    className="w-full bg-white border-2 border-orange-200 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Anual - R$ 259,99
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-46%</span>
                </div>
              </div>
            </div>

            {/* Plano DP - Cálculo de Rescisão */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 relative">
              {/* Header do Card */}
              <div className="mb-6">
                <div className="flex items-center mb-3">
                  <div className="w-6 h-6 bg-gray-800 rounded flex items-center justify-center mr-3">
                    <i className="ri-file-text-line text-white text-sm"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">DP - Cálculo de Rescisão</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Dashboard de Cálculo de Rescisões + Recibos Avulsos + Caixa Postal do DP + Calculadora de INSS/IRRF + Simulador do Seguro Desemprego + Grupo de Membros no WhatsApp
                </p>
              </div>

              {/* Preço */}
              <div className="mb-6">
                <div className="flex items-baseline mb-2">
                  <span className="text-3xl font-bold text-gray-900">R$ 34,99</span>
                  <span className="text-gray-500 ml-1">/mês</span>
                </div>
              </div>

              {/* Lista de Funcionalidades */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm line-through text-red-500">Dashboard de Cálculo de Ponto</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Dashboard de Cálculo de Rescisões</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Gerador de Recibos Avulsos</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Caixa Postal do DP</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Tabela de Rubricas</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Calculadora INSS/IRRF</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Seguro Desemprego</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span className="text-gray-700 text-sm">Grupo WhatsApp</span>
                  <span className="bg-orange-400 text-white text-xs px-2 py-1 rounded ml-2">Bônus</span>
                </div>
              </div>

              {/* Botões de Preço */}
              <div className="space-y-3">
                <button 
                  className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-600 transition-colors whitespace-nowrap"
                  onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                >
                  Mensal - R$ 34,99
                </button>
                <div className="relative">
                  <button 
                    className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Semestral - R$ 147,00
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-30%</span>
                </div>
                <div className="relative">
                  <button 
                    className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap"
                    onClick={() => window.open('https://calculadp.tiagonogueira.com.br/', '_blank')}
                  >
                    Anual - R$ 259,99
                  </button>
                  <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">-38%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Seção adicional mantida */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-white rounded-2xl px-8 py-6 shadow-lg">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-green-600"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">7 Dias de Garantia</p>
                <p className="text-sm text-gray-600">100% do seu dinheiro de volta</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-lock-line text-2xl text-blue-600"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">Pagamento Seguro</p>
                <p className="text-sm text-gray-600">Criptografia SSL 256-bit</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-customer-service-2-line text-2xl text-purple-600"></i>
              </div>
              <div className="text-left">
                <p className="font-semibold text-gray-900">Suporte Premium</p>
                <p className="text-sm text-gray-600">Atendimento especializado</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
